import { create } from 'zustand'

export type SelectedSite = {
  siteId: number
  siteName: string
  isDefault: boolean
}

type SitesState = {
  selectedSite: SelectedSite | null
  setSelectedSite: (site: SelectedSite) => void
  clearSelectedSite: () => void
}

export const useSitesStore = create<SitesState>((set) => ({
  selectedSite: (() => {
    try {
      const saved = localStorage.getItem('selectedSite')
      return saved ? JSON.parse(saved) : null
    } catch {
      return null
    }
  })(),
  setSelectedSite: (site) => {
    localStorage.setItem('selectedSite', JSON.stringify(site))
    set({ selectedSite: site })
  },
  clearSelectedSite: () => {
    localStorage.removeItem('selectedSite')
    set({ selectedSite: null })
  },
}))
